import AppRouter from "components/AppRouter";

const App = (props) => <AppRouter {...props} />;

export default App;
